import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { reduxForm } from 'redux-form';
import { formSettings } from './../settings';
import { FormattedHTMLMessage } from 'react-intl';
import WizardButtons from '../../../../../../components/wizard/navigator/buttons';
import { getBanks, createBankRecord, updateBankRecord } from '../../../../../../reducers/banking';
import Bank from '../../../../../../components/forms/bank';
import mixpanel from 'mixpanel-browser';
class ContractorDirectDepositStep extends React.Component {
    constructor(props) {
        super(props);

        this.submit = this.submit.bind(this);
    }

    componentDidMount() {
        mixpanel.track('WorkerOnboarding', { _data: { branch: 'ic', step: 'ContractorDirectDepositStep' } });

        const { role, getBanks } = this.props;
        getBanks(role);
    }

    submit(values, action) {
        const { role, createBankRecord, updateBankRecord } = this.props;
        const { id, bankName, bankRouting, checkingAccount } = values;

        let persistData = id ? updateBankRecord : createBankRecord;
        let data = { id, name: bankName, routing: bankRouting, account: checkingAccount, primary: true };
        persistData(data, role, action);
    }

    render() {
        const { handleSubmit, onSubmit, back, banks, submitting, regime } = this.props;
        if (!banks) {
            return null;
        }

        return (
            <form onSubmit={handleSubmit(values => this.submit(values, onSubmit))}>
                <div className="row section">
                    <div className="col-xs-12">
                        <FormattedHTMLMessage
                            id={'directDeposit.introText'}
                            defaultMessage={
                                "<p>Setting up direct deposit for payments is critical. Let's take care of that to insure you get paid promptly!</p>"
                            }
                            tagName={'div'}
                        />
                    </div>
                </div>
                <Bank regime={regime} />
                <WizardButtons disabled={submitting} back={{ action: back }} />
            </form>
        );
    }
}

ContractorDirectDepositStep = reduxForm(formSettings)(ContractorDirectDepositStep);

const mapStateToProps = state => {
    let progression = state.onboarding.progression;
    let banks = state.banking.banks;
    let bank = banks && banks.length > 0 ? banks[banks.length - 1] : undefined;

    return {
        role: state.identity.role,
        job: state.onboarding.job,
        banks,
        progression,
        initialValues: {
            id: bank && bank.id ? bank.id : undefined,
            bankName: bank && bank.name ? bank.name : undefined,
            bankRouting: bank && bank.routing ? bank.routing : undefined,
            checkingAccount: bank && bank.account ? bank.account : undefined
        }
    };
};

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            getBanks: getBanks,
            createBankRecord: createBankRecord,
            updateBankRecord: updateBankRecord
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(ContractorDirectDepositStep);



// WEBPACK FOOTER //
// ./src/pages/onboarding/tenants/contractor/steps/contractor/contractorDirectDeposit.jsx